import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SecurityRequestService } from './security-request.service';

@Injectable({
  providedIn: 'root'
})
export class BuscaAvancadaService { 

  constructor(
    private securityRequestService: SecurityRequestService
  ) { }

  post(data: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/BuscaAvancada`, data);
  }

  
  Question(data: any) {
    return this.securityRequestService.post(`${environment.bffApi}/BuscaAvancada/question`, data);
  }
}
